import { startOfMonth } from "date-fns";
import type { ZodType, z } from "zod";

type MonthRangeMessages = {
	tooSoonMessage: string;
	tooFarMessage: string;
};

export const dateInMonthRange = (
	schema: ZodType<Date>,
	min: Date,
	max: Date,
	messages: MonthRangeMessages,
): ZodType<Date, z.ZodTypeDef, Date> =>
	schema
		.refine((val) => startOfMonth(val) >= min, messages.tooSoonMessage)
		.refine((val) => startOfMonth(val) <= max, messages.tooFarMessage);
